import { api } from "@/api/bot-base-api-request";
import { postBotPauseAllCopyTrade } from "@/api/bot/bot-pause-all-copy-trade";
import { useCopyTradeWallets } from "@/hooks/use-copy-trade-data";
import { useWallet } from "@/providers/wallet";
import GradientBorderRadius from "@/ui/gradient-border-radius";
import { useState } from "react";

export const PauseAll = ({ isConnected }: { isConnected: boolean }) => {
  const [isPausing, setIsPausing] = useState(false);
  const { wallets: filteredWallets, refreshWallets } = useCopyTradeWallets();
  const { userId, solanaAddresses, ethereumAddresses, appPubKey } = useWallet();

  const handlePauseAll = async () => {
    if (!isConnected || isPausing) return;
    setIsPausing(true);
    if (!filteredWallets) return setIsPausing(false);

    const promisesWalletTasks = solanaAddresses.map(async (address) => {
      await postBotPauseAllCopyTrade(api, {
        chainId: address?.botChainId,
        walletAddress: address?.address,
        userId,
        appPubKey,
      });
    });
    const promisesEthereumTasks = ethereumAddresses.map(async (address) => {
      await postBotPauseAllCopyTrade(api, {
        chainId: address?.botChainId,
        walletAddress: address?.address,
        userId,
        appPubKey,
      });
    });
    const promises = [...promisesWalletTasks, ...promisesEthereumTasks];

    await Promise.all(promises);
    await refreshWallets();
    setIsPausing(false);
  };

  return (
    <GradientBorderRadius
      gradient="default-border"
      radius="bigger"
      hover="r-100"
    >
      <button
        disabled={!isConnected || isPausing}
        onClick={() => handlePauseAll()}
        className={`w-[9.25rem] h-[1.375rem] text-center text-[0.75rem] font-semibold flex items-center justify-center ${!isConnected || isPausing ? "opacity-50 pointer-events-none " : ""}`}
      >
        {isPausing ? "Pausing wallets.." : `Pause All Wallets`}
      </button>
    </GradientBorderRadius>
  );
};
